if (!customElements.get('widerruf-form')) {
  customElements.define(
    'widerruf-form',
    class WiderrufForm extends HTMLElement {
      connectedCallback() {
        this.companyId = this.dataset.klaviyoCompanyId;
        this.metricName = this.dataset.klaviyoMetric;
        this.formData = {};

        this.step1 = this.querySelector('[data-widerruf-step="1"]');
        this.step2 = this.querySelector('[data-widerruf-step="2"]');
        this.stepSuccess = this.querySelector('[data-widerruf-step="success"]');
        this.errorBox = this.querySelector('[data-widerruf-error]');
        this.confirmButton = this.querySelector('[data-widerruf-confirm]');

        this.querySelector('[data-widerruf-next]').addEventListener('click', () => this.handleNext());
        this.querySelector('[data-widerruf-back]').addEventListener('click', () => this.showStep(1));
        this.confirmButton.addEventListener('click', () => this.handleConfirm());
      }

      showStep(step) {
        this.step1.hidden = step !== 1;
        this.step2.hidden = step !== 2;
        this.stepSuccess.hidden = step !== 'success';
        this.clearError();
      }

      clearError() {
        this.errorBox.hidden = true;
        this.errorBox.textContent = '';
      }

      showError(message) {
        this.errorBox.hidden = false;
        this.errorBox.textContent = message;
      }

      handleNext() {
        this.clearError();
        const fields = this.querySelectorAll('[data-widerruf-field]');
        const data = {};
        let firstInvalid = null;

        fields.forEach((field) => {
          const key = field.dataset.widerrufField;
          const value = field.value.trim();
          if (field.hasAttribute('required') && !value && !firstInvalid) {
            firstInvalid = field;
          }
          data[key] = value;
        });

        if (firstInvalid) {
          this.showError('Bitte fülle alle Pflichtfelder aus.');
          firstInvalid.focus();
          return;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
          this.showError('Bitte gib eine gültige E-Mail-Adresse ein.');
          return;
        }

        this.formData = data;

        this.querySelectorAll('[data-widerruf-summary]').forEach((el) => {
          const key = el.dataset.widerrufSummary;
          el.textContent = data[key] || '';
        });
        const noteWrap = this.querySelector('[data-widerruf-summary-note-wrap]');
        if (noteWrap) noteWrap.hidden = !data.note;

        this.showStep(2);
      }

      async handleConfirm() {
        this.clearError();
        this.confirmButton.setAttribute('aria-disabled', 'true');
        this.confirmButton.classList.add('is-loading');

        const now = new Date();

        try {
          const response = await fetch(`https://a.klaviyo.com/client/events?company_id=${this.companyId}`, {
            method: 'POST',
            headers: {
              revision: '2026-07-15',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                type: 'event',
                attributes: {
                  properties: {
                    Bestellnummer: this.formData.order_number,
                    Name: this.formData.name,
                    Anmerkung: this.formData.note || '',
                    Zeitpunkt: `${now.toLocaleDateString('de-DE')} um ${now.toLocaleTimeString('de-DE', {
                      hour: '2-digit',
                      minute: '2-digit',
                    })} Uhr`,
                  },
                  time: now.toISOString(),
                  metric: {
                    data: {
                      type: 'metric',
                      attributes: { name: this.metricName },
                    },
                  },
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: this.formData.email,
                        first_name: this.formData.name,
                      },
                    },
                  },
                },
              },
            }),
          });

          if (!response.ok) {
            throw new Error(`Klaviyo request failed: ${response.status}`);
          }

          const receipt = this.querySelector('[data-widerruf-receipt]');
          const formattedDate = now.toLocaleDateString('de-DE');
          const formattedTime = now.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
          receipt.textContent = `Eingegangen am ${formattedDate} um ${formattedTime} Uhr für Bestellung ${this.formData.order_number}.`;

          this.showStep('success');
        } catch (error) {
          console.error(error);
          this.showError(
            'Dein Widerruf konnte nicht übermittelt werden. Bitte versuche es erneut oder schreibe uns direkt an info@die-kerzenwerkstatt.de.'
          );
        } finally {
          this.confirmButton.removeAttribute('aria-disabled');
          this.confirmButton.classList.remove('is-loading');
        }
      }
    }
  );
}
